<template>
    <div>
        <b-form-group
            id="input-group-5"
            :label="labelVal"
            label-for="label"
            :class="uploadFileCss ? 'upload-files' : ''"
        >
            <b-form-file
                id="profile-picture"
                ref="file"
                v-bind="$attrs"
                :placeholder="placeholderVal"
                drop-placeholder="Drop file here..."
                :accept="acceptFile"
                class="zindex"
                @change="uploadImage"
            ></b-form-file>
            <slot></slot>
        </b-form-group>
        <b-modal
            id="error-popup"
            ref="errorPopup"
            title="Error in file content"
            :hide-header-close="loading"
            size="md"
            hide-footer
            modal-class="hide-footer"
            no-close-on-backdrop
            no-close-on-esc
            @hidden="onHidden"
        >
            <div class="col-md-12 row-min-space">
                <div class="scrollable more-fields-popup">
                    <h5 style="padding: 20px">
                        Kindly fix the following error/s in your file:
                    </h5>
                    <ul>
                        <li v-for="error in errors" :key="error">
                            {{ error }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-md-12 action-buttons">
                <b-button
                    type="button"
                    variant="primary"
                    :class="loading ? 'disabled' : ''"
                    @click="closePopup"
                >
                    <span class="btn-text">Close</span>
                    <span class="loader"></span>
                </b-button>
            </div>
        </b-modal>
        <b-modal
            id="msg-popup"
            ref="msgPopup"
            title="Error in File Format"
            :hide-header-close="loading"
            size="md"
            hide-footer
            modal-class="hide-footer"
            no-close-on-backdrop
            no-close-on-esc
            @hidden="onHidden"
        >
            <div class="col-md-12 row-min-space">
                <div class="scrollable more-fields-popup">
                    <h5 style="padding: 20px">Invalid File Format</h5>
                    <ul>
                        <li>
                            {{ msgs }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-md-12 action-buttons">
                <b-button
                    type="button"
                    variant="primary"
                    :class="loading ? 'disabled' : ''"
                    @click="closePopupMsg"
                >
                    <span class="btn-text">Close</span>
                    <span class="loader"></span>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
const apiUrl = process.env.VUE_APP_API_URL
export default {
    components: {},
    /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
    props: {
        type: {
            type: String,
            required: true,
        },
        labelVal: {
            type: String,
        },
        placeholderVal: {
            type: String,
            default: 'Choose file to upload',
        },
        acceptFile: {
            type: String,
            default:
                'image/jpeg, image/png, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        },
        uploadFileCss: {
            type: Boolean,
            default: null,
        },
        importFileRun: {
            type: Boolean,
            default: false,
        },
        importCustomFile: {
            type: Boolean,
            default: false,
        },
        size: {
            type: Number,
            default: 20,
        },
        checkedVal: {
            type: Boolean,
            default: false,
        },
        columnConfig: {
            type: Array,
            default: null,
        },
        importDataEntryFile: {
            type: Boolean,
            default: false,
        },
    }, // End of Component > props

    /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
    data() {
        return {
            uploadPercentage: 0,
            errors: '',
            msgs: '',
        }
    }, // End of Component > data

    /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
    computed: {
        ...mapGetters([
            'user',
            'dataSegmentId',
            'formBuilderList',
            'loading',
            'getConfigurationOcrData',
        ]),
    }, // End of Component > computed
    watch: {
        imagePreviewURL(value) {
            this.previewImage = value
        },
    }, // End of Component > watch

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    mounted() {
        this.$refs.file.reset()
    }, // End of Component > mounted

    /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
    methods: {
        //Upload image
        async uploadImage(e) {
            // //console.log('base upload file')
            let self = this
            this.$store.commit('setFileLoading', true)

            const file = e.target.files[0]
            try {
                let formData = new FormData()
                if (file) {
                    let errorOccurred = false
                    const originalName = file.name
                    /*
                        Add the form data we need to submit
                    */

                    formData.append('type', this.type)
                    formData.append('file', file)

                    if (this.formatBytes(file.size)) {
                        this.$toasted.show(
                            `File size must be less than ${this.size} MB`,
                            {
                                duration: 3000,
                                type: ['error'],
                            }
                        )
                        return false
                    }
                    //console.log('Checked val in props', this.checkedVal)
                    let response = await axios.post(
                        apiUrl + 'files/',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                Authorization: `Bearer ${localStorage.getItem(
                                    'vueauth_token'
                                )}`,
                            },

                            onUploadProgress: function (progressEvent) {
                                this.uploadPercentage = parseInt(
                                    Math.round(
                                        (progressEvent.loaded /
                                            progressEvent.total) *
                                            100
                                    )
                                )
                                if (
                                    this.uploadPercentage < 98 &&
                                    this.importFileRun
                                ) {
                                    self.$emit(
                                        'show-progress',
                                        this.uploadPercentage
                                    )
                                }
                            },
                        }
                    )
                    response.data.data.originalName = originalName
                    this.$emit('set-value', response.data.data)

                    if (
                        this.importFileRun &&
                        this.type !== 'bulkCustomersOnboarding' &&
                        this.type !== 'deltaListUploading'
                    ) {
                        let filename = response.data.data.fileName
                        let obj = {}
                        obj.fileName = filename
                        obj.dataSegmentId = this.dataSegmentId

                        await axios.post(
                            apiUrl + 'screening-data/import/',
                            obj,
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${localStorage.getItem(
                                        'vueauth_token'
                                    )}`,
                                },
                            }
                        )
                        this.$emit('show-progress', 100)
                    }

                    if (
                        this.type !== 'bulkCustomersOnboarding' &&
                        this.type == 'deltaListUploading'
                    ) {
                        let filename = response.data.data.fileName
                        let obj = {}
                        obj.fileName = filename
                        obj.dataSegmentId = this.dataSegmentId
                        await axios.post(
                            apiUrl + 'screening-data/importDelta/',
                            obj,
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${localStorage.getItem(
                                        'vueauth_token'
                                    )}`,
                                },
                            }
                        )
                        this.$emit('show-progress', 100)
                    }
                    if (this.importCustomFile) {
                        await this.handleCustomFile(response)
                    }

                    if (this.importDataEntryFile) {
                        this.handleDataEntry(response)
                    }
                    // this.$toasted.show(response.data.message, {
                    //     duration: 2000,
                    //     type: ['success'],
                    // })

                    if (this.type == 'bulkCustomersOnboarding') {
                        let obj = {
                            fileName: response.data.data.fileName,
                            dataSegmentId: this.dataSegmentId,
                            filePath: response.data.data.filePath,
                        }
                        // //console.log(obj)

                        try {
                            let data = await axios.post(
                                apiUrl + 'customers/etl-transform',
                                obj
                            )
                            // //console.log(data)
                            if (data.data.success) {
                                this.$toasted.show(data.data.message, {
                                    duration: 5000,
                                    type: 'success',
                                })

                                this.$emit('show-progress', 100)
                                this.$emit('uploaded', true)
                                if (
                                    data.data.data &&
                                    data.data.data.length !== 0
                                ) {
                                }
                            } else {
                                errorOccurred = true
                                this.$toasted.show(data.data.message, {
                                    duration: 5000,
                                    type: 'error',
                                })
                            }
                        } catch (err) {
                            errorOccurred = true
                            let errMessage = err.response
                                ? err.response.data.message
                                : 'Something went wrong'
                            this.$toasted.show(errMessage, {
                                duration: 5000,
                                type: 'error',
                            })
                        }
                    } else {
                        this.$toasted.show(response.data.message, {
                            duration: 2000,
                            type: 'error',
                        })
                    }
                    if (!errorOccurred) {
                        this.$toasted.show(response.data.message, {
                            duration: 2000,
                            type: ['success'],
                        })
                    }
                }
            } catch (error) {
                //console.log(error)
                let errorMessage = error.response
                    ? error.response.data.message
                    : 'File could not be uploaded'
                this.$store.commit('setError', errorMessage)
            }
            this.$store.commit('setFileLoading', false)
        }, // End of upload image function

        async handleCustomFile(response) {
            // //console.log("checkd value: ",this.checkedVal)
            let filename = response.data.data.fileName
            let obj = {}
            obj.fileName = filename
            obj.dataSegmentId = this.dataSegmentId
            obj.checkedVal = this.checkedVal
            obj.columnConfig = this.columnConfig
            obj.userEmail = this.user.email
            let result = await axios.post(
                apiUrl + 'screening-data/merge/',
                obj,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem(
                            'vueauth_token'
                        )}`,
                    },
                }
            )

            if (result.status == 201) {
                if (result.data.errors) {
                    this.errors = result.data.errors
                    this.$refs.errorPopup.show()
                } else {
                    this.msgs = result.data.message
                    this.$refs.msgPopup.show()
                }

                this.$refs.file.reset()
            } else {
                // this.columnConfig = result.data.columns
                this.$toasted.show(result.data.message, {
                    duration: 3000,
                    type: ['success'],
                })
                this.$emit('show-progress', 100)
                this.$refs.file.reset()
                // this.$emit('set-file', result.data.data)
            }
        },

        async handleDataEntry(response) {
            const ocrData = this.getConfigurationOcrData
            let filename = response.data.data.fileName
            let obj = {}
            obj.fileName = filename
            obj.dataSegmentId = this.dataSegmentId
            obj.restrictDuplicateRecords = ocrData.restrictDuplicateRecords
            let result = await axios.post(
                apiUrl + 'screening-data/merge-data-entry/',
                obj,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem(
                            'vueauth_token'
                        )}`,
                    },
                }
            )
            this.$emit('show-progress', 100)
            // this.$emit('set-file', result.data.data)
        },
        formatBytes(bytes) {
            return (
                (bytes / 1048576).toFixed(3) >
                (typeof this.size != 'undefined' ? this.size : 20)
            )
        }, // End of formatBytes function

        closePopup() {
            this.$refs.errorPopup.hide()
        },
        closePopupMsg() {
            this.$refs.msgPopup.hide()
        },
    },
} // End of export default
</script>
